import { SearchModelBase } from "../utils/SearchModelBase.model";

export class VendorInventorySearch extends SearchModelBase { 
    vendors: string[] = [];
    types: Number[] = [];
    active: Boolean;
    excellenceCenters: string[] = [];
}


// WEBPACK FOOTER //
// ./src/app/models/vendor-inventory/VendorInventorySearch.model.ts